/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/order */
/* eslint-disable camelcase */
import { sentenceCase } from 'change-case';
import { useState, useCallback, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import {
  Card,
  Table,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  Box,
  CircularProgress,
  Chip,
  Link,
  TableFooter
} from '@mui/material';
// routes
import axios, { getErrorMessage } from 'utils/axios';
import useIsMountedRef from 'hooks/useIsMountedRef';
import CRUD from 'utils/Crud';
import { fDateTime } from 'utils/formatTime';
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
import { useSnackbar } from 'notistack';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// sections
import { FormProvider, RHFTextField, RHFSelect } from 'components/hook-form';
import { useForm, Controller } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import uuidv4 from 'utils/uuidv4';


export default function SystemVariables() {
  // const theme = useTheme();
  const { themeStretch } = useSettings();
  const isMountedRef = useIsMountedRef();
  const [dataList, setdataList] = useState([]);
  const [state,setState] = useState({loading:false,loadComplete:false,error:null, isDeleting: false});
  const { enqueueSnackbar } = useSnackbar();


  useEffect(() => {
    getInitData();
  }, []);

  const methods = useForm({});

const {
    reset,
    watch,
    handleSubmit,
    setValue,
    formState: { isSubmitting },
} = methods;

const values = watch();

const onSubmit = async () => {
    try {
      await axios.post(`${CRUD.systemVariables}`,values);
      if(isMountedRef){
          // reset();
          enqueueSnackbar('Update success!');
      }
    } catch (error) {
      enqueueSnackbar(getErrorMessage(error), {color:"error"});
    }
};

  return (
    <Page title="System variables">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="System Variables"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Configurations' },
            { name: 'Variables' }
          ]}
        />

        {state.loading && (
          <Card>
             <Box padding={10} display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Box>
          </Card>
        )}

        {!state.loading && state.error !=null && (
          <Card>
            <Box padding={10} display={"flex"} justifyContent={"center"}>
            <p>Error {state.error} </p>
            </Box>
          </Card>
        )}

        {state.loadComplete && dataList.length < 1 && (
          <Card>
            <Box padding={10} display={"flex"} justifyContent={"center"}>
            <p> There's nothing here yet </p>
            </Box>
          </Card>
        )}

        {state.loadComplete && <Card>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>S/N</TableCell>
                      <TableCell>Field</TableCell>
                      <TableCell>Updated at</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataList.map((row,i) => 
                       (
                        <TableRow
                          hover
                          key={row.id}
                          tabIndex={-1}
                        >
                          <TableCell align="left">{i+1}</TableCell>
                          <TableCell>
                              {sentenceCase(row.label)}
                            <RHFTextField name={row.name} label={row.label} sx={{mt:3}} required />  
                          </TableCell>
                          <TableCell align="left">{fDateTime(row.updated_at)}</TableCell>
                          
                        </TableRow>
                      )
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TableCell >{""}</TableCell>
                      <TableCell align="right">
                        <LoadingButton
                          type="submit" variant="contained" loading={isSubmitting}
                           >Update app variables</LoadingButton>
                      </TableCell>
                      <TableCell >{""}</TableCell>
                    </TableRow>
                  </TableFooter>
                  
                </Table>
              </FormProvider>
            </TableContainer>
          </Scrollbar>

        </Card>}
      </Container>


    </Page>
  );


  async function getInitData(){
    setState({...state,loading:true,loadComplete:false,error:null});   

    try {
      const response = await axios.get(CRUD.systemVariables);

      if (isMountedRef.current) {
        setdataList(response.data);
        response.data.forEach((v)=>{
          setValue(v.name,v.value);
        });
      }
      setState({...state,loading:false,loadComplete:true,error:null})
    } catch (error) {
      setState({...state,loading:false,loadComplete:false,error: getErrorMessage(error)})
    }
  }

}
